export default "__VITE_ASSET__DVMTZKyu__"